import { __extends } from "tslib";
/**
 * Created by Kamil.Adamuszek on 2016-03-22.
 */
import 'classlist-polyfill';
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import BSSInfoHintComponent from '../../bss-infohint-component/js/bss-infohint-component.js';
// import swiper controller to get swiper instance with modules through 'getSwiper' method
import BSSSwiperController from './bss-swiper-controller';
import swiperContent from '../template/swiper-content.hbs';
import template from '../template/swiper-tabs.hbs';
// Swiper tabs presenting model information instead of price
// Used on GB Toyota an GB Lexus
import modelTemplate from '../template/swiper-tabs--model.hbs';
// Swiper tabs presenting price and insurance price in grid
// Used on FR Toyota EPOS
import priceTemplate from '../template/swiper-tabs--price-table.hbs';
import compareTemplate from '../template/swiper-tabs--compare.hbs';
import compareAphTemplate from '../template/swiper-tabs--compare-aph.hbs';
import logger from '@main/externals/bss-package-logger/js/logger';
var defaultScopeSelectors = [
    '.bss-swiper-tabs-nav, .bss-swiper-tabs-nav_price-container, .bss-swiper-tabs-nav_price-legal-text',
];
var templates = {
    defaultTemplate: template,
    modelTemplate: modelTemplate,
    swiperContent: swiperContent,
    priceTemplate: priceTemplate,
    compareTemplate: compareTemplate,
    compareAphTemplate: compareAphTemplate,
};
/**
 * BSSSwiperTabsComponent class
 */
var BSSSwiperTabsComponent = /** @class */ (function (_super) {
    __extends(BSSSwiperTabsComponent, _super);
    /**
     * BSSSwiperTabsComponent constructor
     * @param {object} _entityTemplate simulator template
     * @param {string} containerSelector container selector of components
     * @param {object} config configuration object
     * @param {EventManager} eventManager instance of _EventManager
     * @param {Formatter} formatter instance of Formatter
     * @param {Resolution} resolution device Resolution
     * @param {Object} toolbox
     * @listens {bss-entity-created-$ENTITY-INSTANCE-ID}
     * @listens {bss-swiper-tabs-recalculate-$ENTITY-INSTANCE-ID}
     */
    function BSSSwiperTabsComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, templates, toolbox) || this;
        /**
         * On swiper triggers 'touch' event start:
         * Close all infohints
         * @private
         */
        _this._onTouchStart = function () {
            _this._infohints.forEach(function (infohint) { return infohint.hide(); });
        };
        /**
         * @desc functionality added when swiper is initialized
         * @private
         */
        _this._onTriggerInit = function () {
            logger.info("SwiperTabsComponent: ".concat(_this._config.componentId, " => function : _onTriggerInit"));
            _this._toolbox._.throttle(function () {
                _this._setParentContainerMarginTop();
                _this._updateTabsNavigation(true);
            }, 200)();
        };
        _this._componentVersion = '@@name ver. @@version';
        logger.info("SwiperTabsComponent: => constructor : componentId: ' + ".concat(config.componentId, " | Params: "), _entityTemplate, containerSelector, config, eventManager, formatter, resolution, templates, logger, toolbox);
        _this._setDefaults();
        _this._setCurrentElements();
        _this._prepareSwiperConfiguration();
        _this._setSwiperElements();
        _this._setPromotionIndicatorVisibility();
        _this._initSwiper();
        _this._bindHrefUrl();
        _this._initInfohints();
        _this._initializeTaggingSwiperTabs();
        _this._addEventListeners();
        return _this;
    }
    /**
     * Add event manages subscribers
     */
    BSSSwiperTabsComponent.prototype._addEventListeners = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _addEventListeners"));
        this._eventManager.subscribe("bss-swiper-tabs-recalculate-".concat(this._config.entityInstanceId), this._onImageLoaded.bind(this), this._subscrberId);
        this._eventManager.subscribe("bss-entity-created-".concat(this._config.entityInstanceId), this._onEntityCreated.bind(this), this._subscrberId);
        this._eventManager.subscribe("bss-fonts-ready-".concat(this._config.entityInstanceId), this._adjustHorizontalSwiping.bind(this), this._subscrberId, true);
        this._eventManager.subscribe("bss-component-data-rebound-".concat(this._config.componentId), this._updateCurrent.bind(this), this._subscrberId);
    };
    /**
     * Set default variables
     */
    BSSSwiperTabsComponent.prototype._setDefaults = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _setDefaults"));
        this._componentName = 'bss-swiper-tabs-component';
        /**
         * Determines if burger menu is active
         */
        this.isNoTabsTriggers = this._config.componentTemplate === 'swiperContent';
        this.isAnotherDesign = this._config.anotherDesign === true;
        /**
         * @desc stores all infohint objects added in triggers
         * @type {Array}
         * @private
         */
        this._infohints = [];
        /**
         * @desc stores current swiper index
         * @type {null}
         * @private
         */
        this._currentSliderIndex = null;
        /**
         * @desc stores infohint (in mobile menu wrapper) object
         * @type {null}
         * @private
         */
        this._mobileWrapperInfohint = null;
        /**
         * @desc id used in the event manager to identify events per component
         * @type {string}
         * @private
         */
        this._subscrberId = this.subscriberPrefix + this._config.componentId;
        /**
         * @desc id of entity
         * @type {string}
         * @private
         */
        this._entityId =
            typeof this._entityTemplate.attr('id') === 'undefined'
                ? ''
                : '#' + this._entityTemplate.attr('id') + ' ';
    };
    /**
     * @desc checks for the ammount of products that needs to be sorted and returns
     * @return {Array}
     * @private
     */
    BSSSwiperTabsComponent.prototype._productOrderCheck = function () {
        var resultData = this._config.resultData;
        Object.keys(resultData).forEach(function (key) { return resultData[key] === undefined && delete resultData[key]; });
        var resultLengthCheck = Object.keys(resultData);
        var obj = resultData;
        var arr = [];
        for (var i = 0; i < resultLengthCheck.length; i += 1) {
            arr.push(obj[resultLengthCheck[i]]);
            if (obj[resultLengthCheck[i]].hasOwnProperty('activeTabId')) {
                this.sortActiveTabId = obj[resultLengthCheck[i]].activeTabId;
            }
        }
        arr.sort(function (a, b) { return a.position - b.position; });
        return arr.map(function (item) { return item.productId; });
    };
    /**
     * @desc sort the result of this._config.triggers that sets the order of products that will render based on certain value
     * @return {array} = this._config.triggers
     * @private
     */
    BSSSwiperTabsComponent.prototype._sortProductTriggers = function () {
        var result = this._productOrderCheck();
        var dynamicIndex = Math.random().toString(32).slice(2);
        this._config.triggers = this._config.triggers
            .map(function (item) {
            item[dynamicIndex] = result.indexOf(item.tabId);
            return item;
        })
            .sort(function (a, b) { return a[dynamicIndex] - b[dynamicIndex]; })
            .map(function (item) {
            delete item[dynamicIndex];
            return item;
        });
    };
    /**
     * @desc bind href attribute
     * @private
     */
    BSSSwiperTabsComponent.prototype._bindHrefUrl = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function :  _bindHrefUrl"));
        for (var i = 0, length_1 = this._config.triggers.length; i < length_1; i += 1) {
            var trigger = this._config.triggers[i];
            if (trigger.hasOwnProperty('link')) {
                var productId = trigger.tabId;
                var linkElement = this._componentScope.find(".swiper-slide[data-product=\"".concat(productId, "\"] a"));
                var hrefParams = linkElement.length
                    ? this._toolbox.$(linkElement.data('href')).data('text').split('.')
                    : null;
                var hrefUrl = linkElement.length
                    ? this._config.texts[hrefParams[0]][hrefParams[1]]
                    : null;
                if (linkElement.length) {
                    linkElement.attr('href', hrefUrl);
                }
            }
        }
    };
    /**
     * @desc get data index from slide, searches active slide through tabId, slide id is added in hbs(slide id is created based on this._config.componentId + '_tab-content-' + config.triggers.tabId)
     * @param {string} tabId
     * @return {number}
     * @private
     */
    BSSSwiperTabsComponent.prototype._getActiveSlideIndex = function (tabId) {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _getActiveSlideIndex | Params"), tabId);
        var dataIndex = 0;
        if (tabId) {
            dataIndex = parseInt(this._toolbox
                .$('#' +
                this._config.componentId +
                ' .bss-swiper-tabs-content #' +
                this._config.componentId +
                '_tab-content-' +
                tabId)
                .attr('data-index'));
        }
        dataIndex = dataIndex || 0;
        return dataIndex;
    };
    /**
     * @desc create array of watchers
     * @returns {Array}
     * @private
     */
    BSSSwiperTabsComponent.prototype._prepareWatcher = function () {
        if (!this._config.watcher) {
            return;
        }
        var watcherArray = JSON.parse(JSON.stringify(this._config.watcher));
        this._config.watcher = [];
        for (var i = 0; i < watcherArray.length; i += 1) {
            var watcherString = JSON.stringify(watcherArray[i]);
            var watcherCheck = watcherString.indexOf('$productId$');
            if (watcherCheck !== -1) {
                for (var j = 0; j < this._config.productId.length; j += 1) {
                    var newWatcher = watcherString.replace('$productId$', this._config.productId[j]);
                    newWatcher = JSON.parse(newWatcher);
                    this._config.watcher.push(newWatcher);
                }
            }
            else {
                this._config.watcher.push(watcherArray[i]);
            }
        }
    };
    /**
     * @desc method disables watchers, only watcher for current product is active
     * @param productId
     * @private
     */
    BSSSwiperTabsComponent.prototype._disableWatchers = function (productId) {
        if (!this._watchers) {
            return;
        }
        for (var i = 0; i < this._watchers.length; i += 1) {
            this._watchers[i].disabled = this._watchers[i].product !== productId;
        }
    };
    /**
     * @desc sets current product ID in toolbox
     * @param productId
     * @private
     */
    BSSSwiperTabsComponent.prototype._setCurrentProductId = function (productId) {
        if ('currentProductId' in this._toolbox) {
            this._toolbox.currentProductId = "".concat(productId);
        }
    };
    /**
     * @desc prepare data for swiper
     * @private
     * @override
     */
    BSSSwiperTabsComponent.prototype._prepareData = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _prepareData "));
        this._updateConfigTriggers();
        this.activeTabId = this.sortActiveTabId || this._config.activeTabId;
        this._prepareWatcher();
        this._disableWatchers(this.activeTabId);
        this._setCurrentProductId(this.activeTabId);
        this._prepareTaggingData();
        this._prepareConfigurationBreakPointsData();
        this._prepareTriggersData();
    };
    /**
     * @desc Prepare data for configurationBreakPoints parameter
     * @private
     */
    BSSSwiperTabsComponent.prototype._prepareConfigurationBreakPointsData = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _prepareConfigurationBreakPointsData "));
        var configurationBreakPoints = this._config.triggersSwiperConfiguration
            ? this._config.triggersSwiperConfiguration.breakpoints
            : undefined;
        var triggersLength = this._config.productId.length;
        var numberOfTriggers = this._config.productId.indexOf('general') !== -1
            ? triggersLength - 1
            : triggersLength;
        if (!configurationBreakPoints) {
            return;
        }
        for (var breakpoint in configurationBreakPoints) {
            if (configurationBreakPoints.hasOwnProperty(breakpoint)) {
                for (var item in configurationBreakPoints[breakpoint]) {
                    if ((item === 'slidesPerView' || item === 'slidesPerColumn') &&
                        configurationBreakPoints[breakpoint][item] === '@@numberOfTriggers') {
                        configurationBreakPoints[breakpoint][item] = numberOfTriggers;
                    }
                }
            }
        }
    };
    /**
     * @desc Prepare all necessary data for swiper triggers
     * @private
     */
    BSSSwiperTabsComponent.prototype._prepareTriggersData = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _prepareTriggersData "));
        this._config.iconTriggers = this._config.triggers.some(function (trigger) { return trigger.icon; });
    };
    /**
     * @desc update (equalize) config triggers comparing to resultData products calculated by backend
     * @private
     */
    BSSSwiperTabsComponent.prototype._updateConfigTriggers = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _updateConfigTriggers "));
        var length = this._config.triggers.length;
        if (length) {
            var productIds = Object.keys(JSON.parse(JSON.stringify(this._config.resultData)));
            for (var i = 0; i < length; i += 1) {
                if (typeof this._config.triggers[i] !== 'undefined' &&
                    !productIds.includes(this._config.triggers[i].tabId)) {
                    this._config.triggers.splice(i, 1);
                    i -= 1;
                }
            }
        }
        else {
            logger.error("SwiperTabsComponent: ".concat(this._config.componentId, " => Missing trigger configuration"));
        }
        /**
         * @desc param set in ui-desc, tells if products will be sorted
         * @return {boolean}
         * @private
         */
        var willSortTriggers = this._config.willSortTriggers || false;
        if (willSortTriggers) {
            this._sortProductTriggers();
        }
    };
    /**
     * @desc prepare data for tagging, merge on triggers tagEvent nodes to create one tagEvent for component, tagEvent added in triggers because UI generator can not iterate products in main UI template
     * @private
     */
    BSSSwiperTabsComponent.prototype._prepareTaggingData = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _prepareTaggingData"));
        for (var i = 0, length_2 = this._config.triggers.length; i < length_2; i += 1) {
            if (this._toolbox._.has(this._config.triggers[i], 'tagEvent')) {
                this._config.tagEvent = this._toolbox._.union(this._config.tagEvent, this._config.triggers[i].tagEvent);
            }
        }
    };
    /**
     * @desc prepares swiper configuration correspond to given breakpoint
     * @private
     */
    BSSSwiperTabsComponent.prototype._prepareSwiperConfiguration = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _prepareSwiperConfiguration"));
        var resolutionConfig = this._resolution.resolutionsConfig;
        var activeSlide = this._getActiveSlideIndex(this.activeTabId);
        this._currentSliderIndex = activeSlide;
        this._config.contentSwiperConfiguration.noSwiping =
            'noSwiping' in this._config.contentSwiperConfiguration
                ? // prevents content swiping
                    this._config.contentSwiperConfiguration.noSwiping
                : true;
        if (this._config.contentSwiperConfiguration.noSwiping) {
            this._config.contentSwiperConfiguration.noSwipingClass = this._config
                .contentSwiperConfiguration.noSwipingClass
                ? // default content slide class - for swiping preventing
                    this._config.contentSwiperConfiguration.noSwipingClass
                : 'bss-swiper-tabs-content_slide';
        }
        this._config.contentSwiperConfiguration.initialSlide =
            this._currentSliderIndex;
        var contentBreakpoints = this._config.contentSwiperConfiguration.breakpoints;
        if (contentBreakpoints) {
            for (var item in contentBreakpoints) {
                if (item === 'all') {
                    contentBreakpoints[99999] = contentBreakpoints[item];
                }
                else {
                    var resolution = parseInt(resolutionConfig[item]) - 1;
                    contentBreakpoints[resolution] = contentBreakpoints[item];
                }
                delete contentBreakpoints[item];
            }
        }
        this._addSwiperCallbacks();
        if (!this.isNoTabsTriggers) {
            this._config.triggersSwiperConfiguration.initialSlide = activeSlide;
            var triggersBreakpoints = this._config.triggersSwiperConfiguration.breakpoints;
            if (triggersBreakpoints) {
                for (var item in triggersBreakpoints) {
                    if (item === 'all') {
                        triggersBreakpoints[99999] = triggersBreakpoints[item];
                    }
                    else {
                        var resolution = parseInt(resolutionConfig[item]) - 1;
                        triggersBreakpoints[resolution] = triggersBreakpoints[item];
                    }
                    delete triggersBreakpoints[item];
                }
            }
            this._config.triggersSwiperConfiguration.on =
                this._config.triggersSwiperConfiguration.on || {};
            this._config.triggersSwiperConfiguration.on.init = this._onTriggerInit;
            if (this._config.fixedNavigationXS ||
                this._config.fixedNavigationSM ||
                this._config.fixedNavigationMD ||
                this._config.fixedNavigation) {
                this._fixedNavigation = true;
            }
        }
    };
    /**
     * Add callbacks to swiper instance
     * @private
     */
    BSSSwiperTabsComponent.prototype._addSwiperCallbacks = function () {
        var triggersSwiperConfiguration = this._config.triggersSwiperConfiguration;
        if (triggersSwiperConfiguration) {
            triggersSwiperConfiguration.on = triggersSwiperConfiguration.on || {};
            triggersSwiperConfiguration.on.touchStart = this._onTouchStart;
        }
        this._setSwiperContentEvents();
    };
    /**
     * Setup callback fired on swiper content events:
     * * change loader overlay width on swiper init
     * * change active slide classes on slide change end
     * @private
     */
    BSSSwiperTabsComponent.prototype._setSwiperContentEvents = function () {
        var contentSwiperConfiguration = this._config.contentSwiperConfiguration;
        if (contentSwiperConfiguration) {
            contentSwiperConfiguration.on = contentSwiperConfiguration.on || {};
            contentSwiperConfiguration.on.init = this._setOveralyWidth.bind(this);
            this._window.on("resize.".concat(this._config.componentId), this._toolbox._.throttle(this._setOveralyWidth.bind(this), 200));
            contentSwiperConfiguration.on.slideChangeTransitionEnd =
                this._onSlideChangeEnd.bind(this);
        }
    };
    /**
     * Callback fired just after swiper initialization:
     * Set loader overlay width on swiper content width change
     * @private
     */
    BSSSwiperTabsComponent.prototype._setOveralyWidth = function () {
        var $loaderEl = this._entityTemplate.find('#bssEntityOverlay');
        if (this._resolution.getCurrent !== 'xs') {
            var swiperWidth = this._componentEl.offsetWidth;
            $loaderEl.width(swiperWidth);
        }
        else {
            $loaderEl.removeAttr('width');
        }
    };
    /**
     * @desc on slider move control visibility of real slides and slide to the beginning if all real slides invisible
     * @private
     */
    BSSSwiperTabsComponent.prototype._onTransitionEnd = function (swiper) {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _onTransitionEnd | Params"), swiper);
        if (!this.isAnotherDesign && typeof this._triggerSlides !== 'undefined') {
            if (!this._triggerSlides
                .not('.bss-swiper-tabs-nav_helper-slide')
                .is('.swiper-slide-visible') &&
                typeof this._tabsTriggers !== 'undefined') {
                this._resumeSwiper();
                if (!this._triggeredInfohintClick) {
                    this._tabsTriggers.slideTo(0, 0);
                }
            }
            var hintEl = this._clickedInfohintIndex !== null &&
                typeof this._infohints[this._clickedInfohintIndex] !== 'undefined'
                ? this._infohints[this._clickedInfohintIndex]
                : null;
            if (this._resolution.getCurrent() === 'xs') {
                // close infohints on swipe end, but not when user now uses infohints, clicked on it
                if (this._isClickedInfohint &&
                    this._clickedInfohintIndex !== swiper.activeIndex) {
                    this._closeInfohints();
                    this._triggeredInfohintClick = false;
                }
                // only when infohint is opened
                if (this._isClickedInfohint && hintEl && hintEl._hint.is(':visible')) {
                    this._swiperTriggerClickCallback(this);
                }
                // calculate position of infohint when user uses an infohint, clicked on it
                if (this._isClickedInfohint &&
                    this._triggeredInfohintClick &&
                    typeof this._clickedInfohintIndex !== 'undefined' &&
                    typeof this._infohints[this._clickedInfohintIndex] !== 'undefined') {
                    this._infohints[this._clickedInfohintIndex]._calculatePosition();
                }
            }
            this._triggeredInfohintClick = false;
        }
    };
    /**
     * @desc functionality added only for mobile -> when we can change product with swipe on tabs content
     * @param {Swiper} swiper
     * @emits {bss-tab-changed-$CURRENT-PRODUCT-ID} emit event when tab is changed
     * @emits {bss-close-infohints-$ENTITY-INSTANCE-ID} emit event when tab is changed
     * @emits {bss-resize-iframe-$ENTITY-INSTANCE-ID} emit event when tab is changed
     * @emits {bss-tab-change-$ENTITY-INSTANCE-ID} emit event when tab is changed
     * @emits {bss-entity-prod-change-$ENTITY-INSTANCE-ID} emit event when tab is changed
     * @private
     */
    BSSSwiperTabsComponent.prototype._onSlideChangeEnd = function (swiper) {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _onSlideChangeEnd | Params"), swiper);
        if (swiper) {
            var activeSlide = swiper.slides[swiper.activeIndex];
            var $activeSlideEl = this._toolbox.$(activeSlide);
            var dataIndex = $activeSlideEl.attr('data-index') || 0;
            var swiperIndex = parseInt(dataIndex);
            this._currentSliderIndex = swiperIndex;
            // when we change tab (only on mobile) with swipe on content
            // we must synchronized triggers slider with content
            if (!this.isNoTabsTriggers && this._tabsTriggers) {
                if (!this._isTriggerClicked) {
                    this._tabsTriggers.slideTo(swiperIndex, 0);
                }
                // its because most of browsers doesnt throw event when scroll appears -> but size is changing :/
                var triggerShouldBeUpdated = !this._entityTemplate.is('.browser-edge');
                if (triggerShouldBeUpdated) {
                    this._tabsTriggers.update();
                }
            }
            this._eventManager.publish("bss-tab-change-".concat(this._config.entityInstanceId), this._componentName);
            this._eventManager.publish("bss-tab-changed-".concat(this._config.componentId, "-tab-").concat(this._config.triggers[this._currentSliderIndex].tabId), this._componentName);
            this._eventManager.publish("bss-close-infohints-".concat(this._config.entityInstanceId), this._componentName);
            this._eventManager.publish("bss-resize-iframe-".concat(this._config.entityInstanceId), 'bss-tabs-component', {}, true);
            this._eventManager.publish("bss-entity-prod-change-".concat(this._config.entityInstanceId), this._componentName, { prodID: this._config.triggers[this._currentSliderIndex].tabId });
            this._updateCurrent();
            this._setActiveSlide(swiper);
            this._updateActiveTrigger();
            this._isTriggerClicked = null;
            if (this._tabsNavParent) {
                this._setShadowIndicator();
            }
        }
    };
    /**
     * Slide to active trigger
     * @private
     */
    BSSSwiperTabsComponent.prototype._updateActiveTrigger = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _updateActiveTrigger"));
        if (this._tabsTriggers) {
            this._tabsTriggers.slideTo(this._currentSliderIndex, 400);
        }
    };
    /**
     * Update swipe: lock/unlock
     */
    BSSSwiperTabsComponent.prototype._updateSwipe = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _updateSwipe"));
        if (!this.isAnotherDesign && this.animateTriggers) {
            if (this.animateTriggers.length - this._currentSliderIndex + 1 === 1) {
                this._tabsTriggers.allowSlidePrev = false;
                this._tabsTriggers.allowSlideNext = false;
            }
            else {
                this._tabsTriggers.allowSlidePrev = true;
                this._tabsTriggers.allowSlideNext = true;
            }
            if (this._resolution.getCurrent() !== 'xs') {
                this._stopSwiper();
            }
        }
        if (this.animateTriggers) {
            this._setParentContainerMarginTop();
            this._updateTabsNavigation(true);
        }
    };
    /**
     * @desc gets all element with data-current
     * @private
     * @throws {Wrong data value/text format} throw error when data-value/data-text attribute have wrong format
     */
    BSSSwiperTabsComponent.prototype._setCurrentElements = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _setCurrentElements"));
        this._imageElements = this._entityTemplate.find('.bss-swiper-tabs-wrapper_image');
        var $elements = this._entityTemplate.find('[data-current="true"]');
        var self = this;
        this._currentElements = $elements;
        this._toolbox._.forEach(this._currentElements, function (v) {
            var dataValueTab = self._toolbox.$(v).data('value');
            var dataTextTab = self._toolbox.$(v).data('text');
            v.BSScurrentDataValue = undefined;
            v.BSScurrentDataText = undefined;
            try {
                if (dataValueTab) {
                    dataValueTab = self._toolbox.$(v).data('value').split('.');
                    v.BSScurrentDataValue = dataValueTab[1];
                }
                if (dataTextTab) {
                    dataTextTab = self._toolbox.$(v).data('text').split('.');
                    v.BSScurrentDataText = dataTextTab[1];
                }
            }
            catch (e) {
                throw 'Wrong data value/text format';
            }
        });
        this._updateCurrent();
    };
    /**
     * @desc set swiper selectors
     * @private
     */
    BSSSwiperTabsComponent.prototype._setSwiperElements = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _setSwiperElements"));
        this._navigationEl = this._componentTemplate.find('.bss-swiper-tabs-wrapper_content');
        if (!this.isNoTabsTriggers) {
            this._triggerSlides = this._toolbox
                .$("#".concat(this._config.componentId, " .bss-swiper-tabs-nav"))
                .find('.swiper-slide');
            this._dropdownButtonTrigger = this._toolbox.$("#".concat(this._config.componentId, " .bss-swiper-tabs-dropdown_trigger-btn"));
            this._swiperTabsNavWrapper = this._toolbox.$("#".concat(this._config.componentId, " .bss-swiper-tabs-nav-wrapper"));
        }
    };
    /**
     * @private
     */
    BSSSwiperTabsComponent.prototype._setPromotionIndicatorVisibility = function () {
        var _this = this;
        Object.entries(this._config.resultData).forEach(function (_a) {
            var productId = _a[0], productResultData = _a[1];
            var promotionLabel = _this._componentScope.find("#".concat(productId, "-promotion"));
            var isPromotional = (productResultData || {}).isPromotional;
            var visibility = isPromotional === 'true' || isPromotional === true
                ? 'visible'
                : 'hidden';
            promotionLabel.css('visibility', visibility);
        });
    };
    /**
     * @desc updates data value binding
     * @emits {bss-update-finance-$ENTITY-INSTANCE-ID} event published to connector, sends all current product params, used for save&print functionality
     * @private
     */
    BSSSwiperTabsComponent.prototype._updateCurrent = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _updateCurrent"));
        var currentPriceApr = this._componentScope.find('.bss-swiper-tabs-nav_price-apr');
        var currentLegalText = this._entityTemplate.find('.bss-swiper-tabs-nav_price-legal-text');
        if (currentPriceApr) {
            currentPriceApr.removeAttr('style');
            if (currentLegalText) {
                currentLegalText.removeAttr('style');
            }
        }
        if (typeof this._tabsTriggers !== 'undefined' &&
            typeof this._tabsTriggers.slides !== 'undefined') {
            var $currentElmProduct_1 = this._toolbox
                .$(this._tabsTriggers.slides[this._currentSliderIndex])
                .attr('data-product');
            this._disableWatchers($currentElmProduct_1);
            this._setCurrentProductId($currentElmProduct_1);
            this._eventManager.publish("bss-update-finance-".concat(this._config.entityInstanceId), this._componentName, this._config.resultData[$currentElmProduct_1]);
            this._triggerWatchers();
            for (var i = 0, length_3 = this._currentElements.length; i < length_3; i += 1) {
                var currentElement = this._currentElements[i];
                if (currentElement.BSScurrentDataValue) {
                    currentElement.dataset.value = "".concat($currentElmProduct_1, ".").concat(this._currentElements[i].BSScurrentDataValue);
                    currentElement.dataset.value =
                        $currentElmProduct_1 + '.' + currentElement.BSScurrentDataValue;
                }
                if (currentElement.BSScurrentDataText) {
                    currentElement.dataset.text = "".concat($currentElmProduct_1, ".").concat(this._currentElements[i].BSScurrentDataText);
                }
            }
            if ($currentElmProduct_1) {
                if (this._currentElements.length &&
                    this._currentElements.filter('[data-value]').data()) {
                    var formatter = this._currentElements
                        .filter('[data-value]')
                        .data().formatter;
                    var currentTrigger = this._config.triggers.find(function (trigger) { return trigger.tabId === $currentElmProduct_1; });
                    if (currentTrigger.monthlyPaymentFormatter) {
                        this._currentElements.filter('[data-value]').data().formatter =
                            currentTrigger.monthlyPaymentFormatter;
                    }
                    this._bindValues(this._config.texts, this._currentElements.filter('[data-text]'), $currentElmProduct_1, 'text');
                    this._bindValues(this._config.resultData, this._currentElements.filter('[data-value]'), $currentElmProduct_1, 'value');
                    this._currentElements.filter('[data-value]').data().formatter =
                        formatter;
                }
                else {
                    this._bindValues(this._config.texts, this._currentElements.filter('[data-text]'), $currentElmProduct_1, 'text');
                    this._bindValues(this._config.resultData, this._currentElements.filter('[data-value]'), $currentElmProduct_1, 'value');
                }
            }
        }
        if (currentPriceApr &&
            currentPriceApr.text().replace(/\s{2,}/g, '') === '') {
            currentPriceApr.css('display', 'none');
            if (currentLegalText) {
                currentLegalText.css('margin-top', '0px');
            }
        }
        this._initMobileWrapperInfohint();
        this._displayInsurancePrice();
    };
    BSSSwiperTabsComponent.prototype._displayInsurancePrice = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _displayAdditionalPrice"));
        if (this._config.price && this._config.price.insurance) {
            var currentAdditionalPrice = this._componentScope.find('.bss-swiper-tabs-nav_insurance-price');
            currentAdditionalPrice.removeAttr('style');
            var resultData = this._config.resultData[this.activeTabId];
            var isVisible = (resultData.insuranceCheckboxSelected === 'true' &&
                resultData.insuranceMonthlyPayment) ||
                false;
            if (!isVisible) {
                currentAdditionalPrice.css('display', 'none');
            }
        }
    };
    /**
     * @desc method creates mobile menu wrapper infohint for swiper tabs
     * @private
     */
    BSSSwiperTabsComponent.prototype._initMobileWrapperInfohint = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _initMobileWrapperInfohint"));
        if (this._mobileWrapperInfohint) {
            this._mobileWrapperInfohint.destroy();
        }
        if (this._config &&
            this._config.price &&
            this._config.price.hintText &&
            this._toolbox.currentProductId) {
            var configHint = {};
            this._toolbox.$.extend(true, configHint, this._config);
            configHint.hintText = this._config.price.hintText.replace('$productId$', this._toolbox.currentProductId);
            configHint.componentId = this._config.componentId + '-price-subtext';
            var infohint = new BSSInfoHintComponent(this._entityTemplate, ".".concat(this._config.componentId, "_info-hint-container-price-subtext"), configHint, this._eventManager, this._formatter, this._resolution, this._toolbox);
            this._mobileWrapperInfohint = infohint;
        }
    };
    /**
     * @desc method creates all infohints for swiper tabs
     * @private
     */
    BSSSwiperTabsComponent.prototype._initInfohints = function () {
        var _a;
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _initInfohints"));
        for (var i = 0, length_4 = this._config.triggers.length; i < length_4; i += 1) {
            if (this._config.triggers[i].hintText ||
                this._config.triggers[i].hintTitle) {
                var configHint = {};
                // Deep extend.
                this._toolbox.$.extend(true, configHint, this._config);
                configHint.hintText = this._config.triggers[i].hintText;
                configHint.hintTitle = this._config.triggers[i].hintTitle;
                configHint.componentId = this._config.componentId + '-' + i;
                var infohint = new BSSInfoHintComponent(this._entityTemplate, ".".concat(this._config.componentId, "_info-hint-container-").concat(i), configHint, this._eventManager, this._formatter, this._resolution, this._toolbox);
                this._infohints.push(infohint);
            }
        }
        if ((_a = this._config.price) === null || _a === void 0 ? void 0 : _a.additionalParamInfohint) {
            var additionalParamHint = {};
            this._toolbox.$.extend(true, additionalParamHint, this._config);
            additionalParamHint.componentId = "".concat(this._config.componentId, "-").concat(this._infohints.length);
            additionalParamHint.hintText =
                this._config.price.additionalParamInfohint.replace('$productId$', this._toolbox.currentProductId);
            var additionalParamInfohint = new BSSInfoHintComponent(this._entityTemplate, ".".concat(this._config.componentId, "_info-hint-container--additional-params"), additionalParamHint, this._eventManager, this._formatter, this._resolution, this._toolbox);
            this._infohints.push(additionalParamInfohint);
        }
    };
    /**
     * @desc returns object with outside containers configuration
     * @private
     */
    BSSSwiperTabsComponent.prototype._defineOutsideContainersConfig = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _defineOutsideContainersConfig"));
        var popupSelector;
        var fixedOuterElementSelector;
        var popupContainer;
        var classNameHeader = this._entityTemplate.attr('data-name-header');
        if (this._config.modalContainer) {
            if (typeof this._config.modalContainer === 'object') {
                popupSelector = this._componentScope.closest(this._toolbox.$(this._config.modalContainer[0])).length
                    ? this._toolbox.$(this._config.modalContainer[0])
                    : this._toolbox.$(this._config.modalContainer[1]);
            }
            else {
                popupSelector = this._componentScope.closest(this._toolbox.$(this._config.modalContainer));
            }
        }
        else {
            var classNameBodyContainer = this._entityTemplate.attr('data-name-body');
            if (classNameBodyContainer) {
                popupSelector = this._componentScope.closest(this._toolbox.$(classNameBodyContainer));
            }
        }
        if (this._config.fixedOuterElementSelector) {
            if (typeof this._config.fixedOuterElementSelector === 'object') {
                fixedOuterElementSelector = this._componentScope.closest(this._toolbox.$(this._config.fixedOuterElementSelector[0])).length
                    ? this._toolbox.$(this._config.fixedOuterElementSelector[0])
                    : this._toolbox.$(this._config.fixedOuterElementSelector[1]);
            }
            else {
                fixedOuterElementSelector = this._componentScope.closest(this._toolbox.$(this._config.fixedOuterElementSelector));
            }
        }
        else if (classNameHeader) {
            fixedOuterElementSelector = this._componentScope.closest(this._toolbox.$(classNameHeader));
        }
        var classNameContentContainer = this._entityTemplate.attr('data-name-content');
        if (classNameContentContainer) {
            popupContainer = this._componentScope.closest(this._toolbox.$(classNameContentContainer));
        }
        return { popupSelector: popupSelector, fixedOuterElementSelector: fixedOuterElementSelector, popupContainer: popupContainer };
    };
    /**
     * @desc initSwiper initialize trigger and content swiper, and add event listener on first one
     * @listens {bss-tab-trigger-click-$COMPONENT-ID} emit event when initSlider
     * @emits {bss-entity-prod-change-$ENTITY-INSTANCE-ID} emit event when initSlider
     * @private
     */
    BSSSwiperTabsComponent.prototype._initSwiper = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _initSwiper"));
        /**
         * @type {boolean}
         * @private
         * @desc describe that simulator is in popup
         */
        this._isInPopup = this._entityTemplate.attr('is-popup')
            ? JSON.parse(this._entityTemplate.attr('is-popup'))
            : typeof this._config.isInPopup === 'undefined'
                ? false
                : this._config.isInPopup;
        /**
         * @type {object}
         * @private
         * @desc returns object with outside containers configuration
         */
        this._outsideContainersConfig = this._defineOutsideContainersConfig();
        /**
         * @type {jQuery|HTMLElement}
         * @private
         * @desc global window element
         */
        this._globalWindow = this._isInPopup
            ? this._toolbox.$(this._outsideContainersConfig.popupSelector)
            : this._window;
        /**
         * @type {jQuery|HTMLElement}
         * @private
         * @desc global html, body element
         */
        this._globalHtmlBody = this._isInPopup
            ? this._toolbox.$(this._outsideContainersConfig.popupSelector)
            : this._htmlBody;
        /**
         * @type {jQuery|HTMLElement}
         * @private
         * @desc external fixed element
         */
        this._fixedOuterEl = this._toolbox.$(this._outsideContainersConfig.fixedOuterElementSelector);
        /**
         * @type {boolean}
         * @private
         * @desc tor popup
         */
        this._torPopup = false;
        // check that popup is not popup of bootstrap
        var $popupContainer = this._toolbox.$(this._outsideContainersConfig.popupContainer);
        this._torPopup =
            $popupContainer &&
                ($popupContainer.hasClass('tor-modal-content') ||
                    $popupContainer.attr('id') === 'or-dialog-modal');
        /**
         * @type {Number}
         * @private
         * @desc outer container position
         */
        this._fixedOuterElPosition = null;
        /**
         * @type {Boolean}
         * @private
         * @desc is infohint clicked
         */
        this._isClickedInfohint = false;
        this._clickedInfohintIndex = null;
        if (this._fixedOuterEl.length) {
            this._fixedOuterElPosition = this._fixedOuterEl.position().top;
        }
        else {
            this._fixedOuterEl = null;
        }
        /**
         * @type {jQuery|HTMLElement}
         * @private
         * @desc dropdown element
         */
        this._dropDownContent = this._toolbox.$("#".concat(this._config.componentId, " .bss-swiper-tabs-nav-wrapper"));
        /**
         * @type {jQuery|HTMLElement}
         * @private
         * @desc header element
         */
        this._headerContainer = this._toolbox.$(this._config.headerContainer);
        if (!this._headerContainer.length) {
            this._headerContainer = null;
        }
        if (!this.isNoTabsTriggers) {
            if (this._triggerSlides.length === 1) {
                this._config.triggersSwiperConfiguration.simulateTouch = false;
            }
            var tabsTriggersSwiperController = new BSSSwiperController({
                selector: "".concat(this._entityId, "#").concat(this._config.componentId, " .bss-swiper-tabs-nav"),
                configuration: this._config.triggersSwiperConfiguration,
            });
            this._tabsTriggers = tabsTriggersSwiperController.getSwiper();
        }
        var tabsContentSwiperController = new BSSSwiperController({
            selector: "".concat(this._entityId, "#").concat(this._config.componentId, " .bss-swiper-tabs-content"),
            configuration: this._config.contentSwiperConfiguration,
        });
        this._tabsContent = tabsContentSwiperController.getSwiper();
        if (!this.isNoTabsTriggers) {
            /**
             * @type {jQuery|HTMLElement}
             * @private
             * @desc external fixed element
             */
            this._fixedOuterEl = this._toolbox.$(this._outsideContainersConfig.fixedOuterElementSelector);
            /**
             * @type {Number}
             * @private
             * @desc outer container position
             */
            this._fixedOuterElPosition = null;
            if (this._fixedOuterEl.length) {
                this._fixedOuterElPosition = this._fixedOuterEl.position().top;
            }
            else {
                this._fixedOuterEl = null;
            }
            this._initDropDownTriggerBtn();
            if (window.innerWidth <= this._resolution.resolutionsConfig.smMin) {
                this._swiperTabsNavWrapper
                    .css('display', 'block')
                    .removeClass('is-open');
                this._dropdownButtonTrigger.removeClass('is-active');
                this._tabsTriggers.update();
            }
            this._triggerSlides.on("click.".concat(this._config.componentId), this._swiperTriggerClickCallback.bind(this));
            this._addTabChangeEvents();
            this._eventManager.subscribe("bss-tab-trigger-click-".concat(this._config.componentId), this._onTriggerClickEvent.bind(this), this._subscrberId);
            this._updateCurrent();
            // there is some issue for content swiper on ie10 and ie11 -> needs recalculation after init/reinit
            if (this._isIEBelow11()) {
                this._tabsContent.update();
            }
            this._triggersAdjust();
        }
        else {
            this._addTabChangeEvents();
        }
        if (this._isSafari()) {
            this._window.on("resize.".concat(this._config.componentId), this._toolbox._.throttle(this._toolbox._.bind(this._setParentContainerMarginBottomForSafari, this), 200));
            this._setParentContainerMarginBottomForSafari();
        }
        this._addProductAmountClass();
        this._eventManager.publish("bss-entity-prod-change-".concat(this._config.entityInstanceId), this._componentName, { prodID: this._config.triggers[this._currentSliderIndex].tabId });
    };
    /**
     * Add to the swiper wrapper class with amount of products
     * @private
     */
    BSSSwiperTabsComponent.prototype._addProductAmountClass = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _addProductAmountClass"));
        var length = this._config.triggers.length;
        var $component = this._toolbox.$("#".concat(this._config.componentId));
        $component.addClass("bss-swiper-tabs--".concat(length, "products"));
    };
    /**
     * @desc Init dropdown trigger button
     * hidden for single product otherwise add click event listener
     * @private
     */
    BSSSwiperTabsComponent.prototype._initDropDownTriggerBtn = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _initDropDownTriggerBtn"));
        var triggersLength = this._config.triggers.length;
        if (triggersLength === 1) {
            var noTriggerClass = 'no-trigger-btn';
            this._navigationEl.addClass(noTriggerClass);
        }
        else {
            /**
             * @type {jQuery|HTMLElement}
             * @private
             * @desc dropdownButtonTrigger element
             */
            this._dropdownButtonTrigger.on("click.".concat(this._config.componentId), this._onClickDropdownTrigger.bind(this));
        }
    };
    /**
     * @desc unsubscribe from tab changed event
     * if isNoTabsTriggers set to true(no navigation tabs) => unsubscribe from trigger 'bss-tab-changed-{componentId}-product-{tabId}'.
     * @private method
     */
    BSSSwiperTabsComponent.prototype._removeTabChangeEvents = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _removeTabChangeEvents"));
        if (this.isNoTabsTriggers) {
            for (var i = 0, length_5 = this._config.triggers.length; i < length_5; i += 1) {
                this._eventManager.unsubscribe("bss-tab-changed-".concat(this._config.componentId, "-product-").concat(this._config.triggers[i].tabId), this._onTabChangeEvent.bind(this, i), this._subscrberId);
            }
        }
        else {
            for (var i = 0, length_6 = this._triggerSlides.length; i < length_6; i += 1) {
                this._eventManager.unsubscribe("bss-tab-changed-".concat(this._config.componentId, "-tab-").concat(i), this._onTabChangeEvent.bind(this, i), this._subscrberId);
            }
        }
    };
    /**
     * @desc subscribe for tab changed event
     * if isNoTabsTriggers set to true(no navigation tabs) => subscribe on trigger 'bss-tab-changed-{componentId}-product-{tabId}'.
     * @listens {bss-tab-changed-$COMPONENT-ID} emit event when initSlider
     * @private
     */
    BSSSwiperTabsComponent.prototype._addTabChangeEvents = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _addTabChangeEvents"));
        if (this.isNoTabsTriggers) {
            for (var i = 0, length_7 = this._config.triggers.length; i < length_7; i += 1) {
                this._eventManager.subscribe("bss-tab-changed-".concat(this._config.componentId, "-product-").concat(this._config.triggers[i].tabId), this._onTabChangeEvent.bind(this, i), this._subscrberId, true);
            }
        }
        else {
            for (var i = 0, length_8 = this._triggerSlides.length; i < length_8; i += 1) {
                this._eventManager.subscribe("bss-tab-changed-".concat(this._config.componentId, "-tab-").concat(i), this._onTabChangeEvent.bind(this, i), this._subscrberId);
            }
        }
    };
    /**
     * @desc swiper tabs trigger - callback on trigger click
     * @param ev {object} - jquery event object
     * @emits {bss-tab-changed-$COMPONENT-ID-tab-$TAB-INDEX} emit swiper trigger is clicked
     * @private
     */
    BSSSwiperTabsComponent.prototype._swiperTriggerClickCallback = function (ev) {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _swiperTriggerClickCallback | Param: "), ev);
        this._isTriggerClicked = true;
        if (this._resolution.getCurrent() !== 'xs' && this._isClickedInfohint) {
            this._isClickedInfohint = false;
            this._triggeredInfohintClick = false;
            this._clickedInfohintIndex = null;
            return;
        }
        if (this._toolbox.$(ev.currentTarget).index() ===
            this._tabsContent.activeIndex) {
            return;
        }
        this._eventManager.publish("bss-tab-change-".concat(this._config.entityInstanceId), this._componentName);
        this._eventManager.publish("bss-tab-changed-".concat(this._config.componentId, "-tab-").concat(this._toolbox
            .$(ev.currentTarget)
            .index()), this._componentName);
    };
    /**
     * @desc Swiper mobile button trigger function, toggle class
     * @emits {bss-tab-trigger-click-$COMPONENT-ID} emit event when swiper dropdown button is clicked
     * @private
     */
    BSSSwiperTabsComponent.prototype._onClickDropdownTrigger = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _onClickDropdownTrigger"));
        this._dropdownButtonTrigger.toggleClass('is-active');
        this._eventManager.publish("bss-tab-trigger-click-".concat(this._config.componentId), this._componentName);
    };
    /**
     * @desc adjusts navigation horizontal swiping for mobile resolution
     * @private
     */
    BSSSwiperTabsComponent.prototype._adjustHorizontalSwiping = function () {
        var _this = this;
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _adjustHorizontalSwiping"));
        if (this._resolution.getCurrent() === 'xs') {
            this._triggerSlides
                .find('.bss-info-hint_btn')
                .off("click.".concat(this._config.componentId))
                .on("click.".concat(this._config.componentId), this._onInfohintClick.bind(this));
            this._toolbox._.throttle(function () {
                _this._setParentContainerMarginTop();
                _this._updateTabsNavigation();
                _this._onTransitionEnd(_this);
            }, 200);
            if (this._tabsNavParent) {
                this._setShadowIndicator();
            }
            if (!this.isAnotherDesign &&
                typeof this._config.triggersSwiperConfiguration.on.transitionEnd ===
                    'undefined' &&
                this._toolbox.$("#".concat(this._config.componentId)).is(':visible')) {
                this._config.triggersSwiperConfiguration.on =
                    this._config.triggersSwiperConfiguration.on || {};
                this._config.triggersSwiperConfiguration.on.transitionEnd =
                    this._onTransitionEnd.bind(this);
            }
        }
        else {
            this._setParentContainerMarginTop();
        }
    };
    /**
     * @desc actions on infohint click
     * @param ev {object} - jquery event object
     * @private
     */
    BSSSwiperTabsComponent.prototype._onInfohintClick = function (ev) {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _onInfohintClick"));
        var infohintIdIndex = parseInt(this._toolbox
            .$(ev.currentTarget)
            .attr('id')
            .replace('navigationTabs-', '')
            .substr(0, 1));
        this._isClickedInfohint = true;
        this._triggeredInfohintClick = true;
        this._clickedInfohintIndex =
            typeof infohintIdIndex !== 'undefined' ? infohintIdIndex : null;
    };
    /**
     * @desc callback on tab change
     * @emits {'bss-tab-change-ended-$ENTITY-INSTANCE-ID} emit event when change tab is ended
     * @private
     */
    BSSSwiperTabsComponent.prototype._onTabChangeEvent = function (i) {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _onTabChangeEvent | Param"), i);
        if (!this.isAnotherDesign && this._resolution.getCurrent() === 'xs') {
            this._adjustHorizontalSwiping(i);
        }
        if (this._tabsContent.length > 1) {
            this._tabsContent[0].slideTo(i, 0);
            this._tabsContent[1].slideTo(i, 0);
        }
        else {
            this._tabsContent.slideTo(i, 0);
            if (!this.isAnotherDesign && this._lockedSwiping) {
                this._stopSwiper();
            }
        }
        this._currentSliderIndex = i;
        this._eventManager.publish("bss-tab-change-ended-".concat(this._config.entityInstanceId), this._componentName);
        if (this.isAnotherDesign) {
            this._triggerDropdown();
        }
        // update top margin for a parent container & navigation tabs content node calculations after tab change
        this._setParentContainerMarginTop();
        this._updateTabsNavigation(true);
    };
    /**
     * @desc callback on click mobile menu button
     * @emits {bss-close-infohints-$ENTITY-INSTANCE-ID} emit event tab click is triggered
     * @emits {bss-resize-iframe-$ENTITY-INSTANCE-ID} emit event tab is changed
     * @private
     */
    BSSSwiperTabsComponent.prototype._onTriggerClickEvent = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _onTriggerClickEvent"));
        this._eventManager.publish("bss-close-infohints-".concat(this._config.entityInstanceId), this._componentName);
        this._eventManager.publish("bss-resize-iframe-".concat(this._config.entityInstanceId), 'bss-tabs-component', {}, true);
        if (this.isAnotherDesign) {
            this._triggerDropdown();
        }
    };
    /**
     * @desc triggers trigger tabs dropdown
     * @private
     */
    BSSSwiperTabsComponent.prototype._triggerDropdown = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _triggerDropdown"));
        if (this.isNoTabsTriggers || this._resolution.getCurrent() !== 'xs') {
            return;
        }
        this._dropDownContent = this._toolbox.$("#".concat(this._config.componentId, " .bss-swiper-tabs-nav-wrapper"));
        if (this._dropDownContent.hasClass('is-open')) {
            this._dropDownContent.slideUp(this._config.slideDuration, this._hideTriggersCallback.bind(this, this._dropDownContent));
        }
        else {
            this._tabsTriggers.update();
            this._dropDownContent.addClass('is-moved');
            if (this.isAnotherDesign) {
                this._dropDownContent.css({ display: 'none' });
            }
            this._dropDownContent.slideDown(this._config.slideDuration, this._showTriggersCallback.bind(this, this._dropDownContent));
        }
    };
    /**
     * @desc callback for mobile triggers show action
     * @param {jQuery|HTMLElement} dropDownContent - reference to dropdown content
     * @private
     */
    BSSSwiperTabsComponent.prototype._showTriggersCallback = function (dropDownContent) {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _showTriggersCallback"), dropDownContent);
        if (this.isNoTabsTriggers) {
            return;
        }
        this._dropDownContent.addClass('is-open');
    };
    /**
     * @desc callback for mobile triggers hide action
     * @param {jQuery|HTMLElement} dropDownContent - reference to dropdown content
     * @private
     */
    BSSSwiperTabsComponent.prototype._hideTriggersCallback = function (dropDownContent) {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _hideTriggersCallback"), dropDownContent);
        if (this.isNoTabsTriggers) {
            return;
        }
        this._dropDownContent.removeClass('is-open');
        this._dropdownButtonTrigger.removeClass('is-active');
    };
    /**
     * @desc limits the component refresh scope
     * @private
     */
    BSSSwiperTabsComponent.prototype._prepareComponentScope = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _prepareComponentScope"));
        var componentScopeSelectors = this._config.componentScopeSelectors || defaultScopeSelectors;
        var scopeSelector = componentScopeSelectors[0];
        for (var i = 1, length_9 = componentScopeSelectors.length; i < length_9; i += 1) {
            scopeSelector += ", ".concat(componentScopeSelectors[i]);
        }
        this._componentScope = this._componentTemplate.find(scopeSelector);
    };
    /**
     * @desc onSlideChangeEnd callback sets active slide
     * @param {Slider} slider - slider object
     * @private
     */
    BSSSwiperTabsComponent.prototype._setActiveSlide = function (slider) {
        if (slider === void 0) { slider = {}; }
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _setActiveSlide | Params: "), slider);
        if (!this.isNoTabsTriggers) {
            var activeIndex = (slider || 0).activeIndex;
            this._triggerSlides.removeClass('is-active');
            this._toolbox.$(this._triggerSlides[activeIndex]).addClass('is-active');
        }
        this._changeClassSimulator(slider);
        this._changeIconDropdownMenu(slider);
    };
    /**
     * @desc set shadow on right side
     * @private
     */
    BSSSwiperTabsComponent.prototype._setShadowIndicator = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _setShadowIndicator"));
        var rightShadowIndicator = this._tabsNavParent.find('.bss-swiper-tabs-button-next') || null;
        var realSwiperWidth = Math.round(this._getRealSwiperWidth());
        var swiperWrapperWidth = Math.round(this._swiperTabsNavWrapper[0].getBoundingClientRect().width);
        if (swiperWrapperWidth >= realSwiperWidth) {
            this._stopSwiper();
            if (rightShadowIndicator) {
                rightShadowIndicator.hide();
            }
        }
        else {
            this._resumeSwiper();
            if (rightShadowIndicator) {
                var translate = this._tabsTriggers.translate;
                if (swiperWrapperWidth - translate < realSwiperWidth) {
                    rightShadowIndicator.show();
                }
                else {
                    rightShadowIndicator.hide();
                }
            }
        }
    };
    /**
     * Get summary width of swiper slides
     * @returns {number}
     * @private
     */
    BSSSwiperTabsComponent.prototype._getRealSwiperWidth = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _getRealSwiperWidth"));
        var $realSlides = this._triggerSlides.not('.bss-swiper-tabs-nav_helper-slide');
        var realSwiperWidth = 0;
        $realSlides.each(function (_i, el) {
            realSwiperWidth += el.getBoundingClientRect().width;
        });
        return realSwiperWidth;
    };
    /**
     * Stop swiper swipe
     * @private
     */
    BSSSwiperTabsComponent.prototype._stopSwiper = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _stopSwiper"));
        this._lockedSwiping = true;
        this._tabsTriggers.allowSlidePrev = false;
        this._tabsTriggers.allowSlideNext = false;
    };
    /**
     * Enable swiper swipe
     * @private
     */
    BSSSwiperTabsComponent.prototype._resumeSwiper = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _resumeSwiper"));
        this._lockedSwiping = false;
        this._tabsTriggers.allowSlidePrev = true;
        this._tabsTriggers.allowSlideNext = true;
    };
    /**
     * @desc remove additional class in entity
     * @private
     */
    BSSSwiperTabsComponent.prototype._removeclassTrigger = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _removeclassTrigger"));
        if (this.isNoTabsTriggers) {
            return;
        }
        for (var j = 0, length_10 = this._config.triggers.length; j < length_10; j += 1) {
            this._entityTemplate.removeClass(this._config.triggers[j].class);
        }
    };
    /**
     * @desc change class simulator in entity
     * @param {Slider} slider - slider object
     * @private
     */
    BSSSwiperTabsComponent.prototype._changeClassSimulator = function (slider) {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _changeClassSimulator | Params: "), slider);
        this._removeclassTrigger();
        this._entityTemplate.addClass(this._config.triggers[slider.activeIndex].class);
    };
    /**
     * @desc change img icon in dropdown on xs
     * @param {Slider} slider - slider object
     * @private
     */
    BSSSwiperTabsComponent.prototype._changeIconDropdownMenu = function (slider) {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _changeIconDropdownMenu | Params: "), slider);
        if (this.isNoTabsTriggers) {
            return;
        }
        this._img = this._entityTemplate.find('.bss-swiper-tabs-nav_price-apr-icon_img');
        this._container = this._img.parents('.bss-swiper-tabs-nav_price-container');
        if (this._config.iconTriggers) {
            this._img.attr('src', this._config.triggers[slider.activeIndex].icon);
            if (this._config.triggers[slider.activeIndex].icon) {
                this._container.addClass('icon-active');
            }
            else {
                this._container.removeClass('icon-active');
            }
        }
    };
    /**
     * @desc reset fixed navigation when is disabled
     * @private
     */
    BSSSwiperTabsComponent.prototype._resetFixedTabNavigation = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _resetFixedTabNavigation"));
        this._navigationEl
            .removeClass('is-absolute')
            .removeClass('is-fixed')
            .removeAttr('style');
        this._tabsNavParent.removeAttr('style');
        this._canFixNav = false;
    };
    /**
     * @desc update fixed navigation on window resize
     * @return {Boolean} return true if navigation tabs should be fixed
     * @private
     */
    BSSSwiperTabsComponent.prototype._onResizeFixedTabNavigation = function () {
        var _this = this;
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _onResizeFixedTabNavigation"));
        var res = this._resolution.getCurrent();
        if (res === 'xs') {
            this._tabsNavParent = this._tabsNavParentXS;
            this._tabsNavParentSM.removeAttr('style');
            this._tabsNavParentMD.removeAttr('style');
            if (!this.isAnotherDesign) {
                this._triggerSlides.removeAttr('style');
            }
            if (!this.isAnotherDesign) {
                this._tabsTriggers.update();
                this._triggerSlides
                    .not('.bss-swiper-tabs-nav_helper-slide')
                    .removeAttr('style');
                this._adjustHorizontalSwiping();
                if (!this._tabsTriggers.isBeginning) {
                    this._resumeSwiper();
                    if (this._lockedSwiping) {
                        this._tabsTriggers.slideTo(0, 0);
                        this._stopSwiper();
                    }
                }
            }
            if (!this._isFixedNavigationXS) {
                this._resetFixedTabNavigation();
                return;
            }
        }
        else if (res === 'sm') {
            this._tabsNavParent = this._tabsNavParentSM;
            this._tabsNavParentXS.removeAttr('style');
            this._tabsNavParentMD.removeAttr('style');
            if (!this.isAnotherDesign) {
                this._stopSwiper();
                this._tabsNavParent.find('.bss-swiper-tabs-button-next').hide();
            }
            if (!this._isFixedNavigationSM) {
                this._resetFixedTabNavigation();
                return;
            }
        }
        else {
            this._tabsNavParent = this._tabsNavParentMD;
            this._tabsNavParentXS.removeAttr('style');
            this._tabsNavParentSM.removeAttr('style');
            if (!this._isFixedNavigationMD) {
                this._resetFixedTabNavigation();
                return;
            }
        }
        // if there is fixed nav in this view
        this._canFixNav = !!this._isInPopup;
        this._toolbox._.throttle(function () {
            _this._setParentContainerMarginTop();
            _this._updateTabsNavigation(true);
        }, 200)();
    };
    /**
     * @desc set extra margin-top to the parent of fixed navigation
     * @private
     */
    BSSSwiperTabsComponent.prototype._setParentContainerMarginTop = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _setParentContainerMarginTop"));
        if (this._tabsNavParent) {
            this._tabsNavParent.removeAttr('style');
            this._tabsNavParent.css('position', 'relative');
            var res = this._resolution.getCurrent();
            if (!((res === 'xs' && !this._isFixedNavigationXS) ||
                (res === 'sm' && !this._isFixedNavigationSM) ||
                (res === 'md' && !this._isFixedNavigationMD))) {
                var margin = parseInt(this._tabsNavParent.css('margin-top')) +
                    parseInt(this._navigationEl.outerHeight(true));
                if (this._isInPopup && this.isAnotherDesign) {
                    // Remove additional padding of modal body if exists to cover swiper tabs by placeholder
                    this._modalBody = this._entityTemplate.closest('.modal-body');
                    if (this._modalBody.length) {
                        margin -= parseInt(this._modalBody.css('padding-top'), 10);
                    }
                }
                if (this._torPopup && this._isBrowserForSticky) {
                    this._tabsNavParent.removeAttr('style');
                }
                else {
                    this._tabsNavParent.css('margin-top', "".concat(margin, "px"));
                }
            }
        }
    };
    /**
     * @desc method override to update top margin for a parent container
     * @param {String} publisherName
     * @param {Record<string, any>} data
     * @override
     * @private
     */
    BSSSwiperTabsComponent.prototype.update = function (publisherName, data) {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : update | Params"), publisherName, data);
        _super.prototype.update.call(this, publisherName, data);
        // update top margin for a parent container & navigation tabs content node calculations on every update
        this._setParentContainerMarginTop();
        this._updateTabsNavigation(true);
    };
    /**
     * @desc get navigation offset top - based on outer fixed element height and position top
     * @return {Number} outerOffset - navigation offset top
     * @private
     */
    BSSSwiperTabsComponent.prototype._getFixedOuterOffset = function () {
        var outerOffset = 0;
        if (this._fixedOuterEl && this._fixedOuterEl.is(':visible')) {
            outerOffset =
                this._fixedOuterEl.outerHeight() + this._fixedOuterElPosition - 1;
        }
        return outerOffset;
    };
    /**
     * @desc update fixed navigation based on window scroll
     * @param {Boolean} [isInitCall] - if true force calculations (on init and after window resize)
     * @private
     */
    BSSSwiperTabsComponent.prototype._updateTabsNavigation = function (isInitCall) {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _updateTabsNavigation"));
        if (!this._canFixNav) {
            return;
        }
        var scrollTop = this._globalWindow.scrollTop();
        var navHeight = this._navigationEl.outerHeight();
        var compHeight = this._tabsNavParent.outerHeight();
        var compWidth = this._tabsNavParent.outerWidth();
        var outerOffset = this._getFixedOuterOffset();
        var minScrollTop = this._isInPopup
            ? parseInt(this._tabsNavParent
                .closest(this._outsideContainersConfig.popupSelector)
                .css('paddingTop'), 10)
            : this._tabsNavParent.offset().top - outerOffset - navHeight;
        var maxScrollTop = this._isInPopup
            ? this._globalWindow.scrollTop() - navHeight + compHeight
            : minScrollTop + compHeight;
        var offset;
        var top;
        var left;
        if (this._torPopup && this._isBrowserForSticky) {
            this._navigationEl.removeAttr('style');
            this._navigationEl
                .removeClass('is-absolute')
                .removeClass('is-fixed')
                .addClass('is-sticky');
            this._tabsNavParent.css('margin-top', '-1px');
        }
        else if (scrollTop <= maxScrollTop) {
            if (!this._navigationEl.hasClass('is-fixed') && !this._isInPopup) {
                this._navigationEl.removeClass('is-absolute').addClass('is-fixed').css({
                    top: outerOffset,
                    width: compWidth,
                });
            }
            else if (this._isInPopup) {
                var pixelsToAdd = 0;
                var popupHeader = this._tabsNavParent
                    .closest(this._outsideContainersConfig.popupSelector)
                    .prev(this._outsideContainersConfig.fixedOuterElementSelector);
                var isPupupStickedToTop = void 0;
                if (popupHeader.length) {
                    isPupupStickedToTop = popupHeader.offset().top === 0;
                    pixelsToAdd = isPupupStickedToTop ? 0 : 1;
                    top =
                        parseFloat(popupHeader[0].getBoundingClientRect().height.toFixed(2)) + pixelsToAdd;
                }
                else {
                    if (this._tabsNavParent.closest(this._outsideContainersConfig.popupSelector) &&
                        this._tabsNavParent
                            .closest(this._outsideContainersConfig.popupSelector)
                            .offset()) {
                        top = this._tabsNavParent.closest(this._outsideContainersConfig.popupSelector)[0].offsetTop;
                    }
                    else {
                        top = 0;
                    }
                    pixelsToAdd = 0;
                }
                this._navigationEl.removeClass('is-absolute').addClass('is-fixed').css({
                    top: top,
                    width: compWidth,
                });
                if (this._torPopup) {
                    this._navigationEl.css({
                        top: top - pixelsToAdd - 1,
                        left: left,
                    });
                }
            }
        }
        else if (scrollTop > maxScrollTop) {
            if (isInitCall || !this._navigationEl.hasClass('is-absolute')) {
                this._navigationEl.removeClass('is-fixed').addClass('is-absolute').css({
                    top: 0,
                    left: 'auto',
                });
                offset =
                    this._tabsNavParent.offset().top - this._navigationEl.offset().top;
                top = compHeight - navHeight + offset;
                this._navigationEl.css({ top: top, width: compWidth });
            }
        }
    };
    /**
     * @desc initialize fixed navigation
     * @listens {bss-start-scroll-for-$ENTITY-INSTANCE-ID}
     * @listens {bss-stop-scroll-for-$ENTITY-INSTANCE-ID}
     * @listens {bss-start-resize-for-$ENTITY-INSTANCE-ID}
     * @listens {bss-stop-resize-for-$ENTITY-INSTANCE-ID}
     * @private
     */
    BSSSwiperTabsComponent.prototype._initTabsNavigation = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _initTabsNavigation"));
        this._setBrowserForStickyFlag();
        this._isFixedNavigationXS = !!this._config.fixedNavigationXS;
        this._isFixedNavigationSM = !!this._config.fixedNavigationSM;
        this._isFixedNavigationMD = !!this._config.fixedNavigationMD;
        if (!this._isFixedNavigationXS &&
            !this._isFixedNavigationSM &&
            !this._isFixedNavigationMD) {
            return;
        }
        var _a = this._config, fixedNavContainerXS = _a.fixedNavContainerXS, fixedNavContainerSM = _a.fixedNavContainerSM, fixedNavContainerMD = _a.fixedNavContainerMD;
        var $componentEl = this._toolbox.$("#".concat(this._config.containerId));
        this._tabsNavParentXS =
            fixedNavContainerXS && this._toolbox.$(fixedNavContainerXS)
                ? this._toolbox.$(fixedNavContainerXS)
                : $componentEl;
        this._tabsNavParentSM =
            fixedNavContainerSM && this._toolbox.$(fixedNavContainerSM)
                ? this._toolbox.$(fixedNavContainerSM)
                : $componentEl;
        this._tabsNavParentMD =
            fixedNavContainerMD && this._toolbox.$(fixedNavContainerMD)
                ? this._toolbox.$(fixedNavContainerMD)
                : $componentEl;
        if (!this._tabsNavParentXS.length) {
            this._isFixedNavigationXS = false;
        }
        if (!this._tabsNavParentSM.length) {
            this._isFixedNavigationSM = false;
        }
        if (!this._tabsNavParentMD.length) {
            this._isFixedNavigationMD = false;
        }
        this._isScrollEventOff = true;
        this._isResizeEventOff = true;
        this._bindScroll();
        this._bindResize();
        this._eventManager.subscribe("bss-start-scroll-for-".concat(this._config.entityInstanceId), this._bindScroll.bind(this), this._subscrberId);
        this._eventManager.subscribe("bss-stop-scroll-for-".concat(this._config.entityInstanceId), this._unbindScroll.bind(this), this._subscrberId);
        this._eventManager.subscribe("bss-start-resize-for-".concat(this._config.entityInstanceId), this._bindResize.bind(this), this._subscrberId);
        this._eventManager.subscribe("bss-stop-resize-for-".concat(this._config.entityInstanceId), this._unbindResize.bind(this), this._subscrberId);
        if (this._fixedNavigation) {
            this._onResizeFixedTabNavigation();
        }
    };
    /**
     * @desc set flag if a position 'sticky' and corresponding to it calculations should be applied for the navigation - in relation to a browser type
     * @type {boolean}
     * @private
     */
    BSSSwiperTabsComponent.prototype._setBrowserForStickyFlag = function () {
        logger.info("SwiperTabsComponent ".concat(this._config.componentId, " => function : _setBrowserForStickyFlag"));
        this._isBrowserForSticky =
            this._entityTemplate.hasClass('browser-chrome') ||
                this._entityTemplate.hasClass('browser-safari') ||
                this._entityTemplate.hasClass('browser-firefox');
    };
    /**
     * @desc on image loaded
     * @private
     */
    BSSSwiperTabsComponent.prototype._onImageLoaded = function () {
        logger.info("SwiperTabsComponent ".concat(this._config.componentId, " => function : _onImageLoaded"));
        var res = this._resolution.getCurrent();
        if ((res === 'xs' && this._isFixedNavigationXS) ||
            (res === 'sm' && this._isFixedNavigationSM) ||
            (res !== 'xs' && res !== 'sm' && this._isFixedNavigationMD)) {
            this._canFixNav = true;
        }
        this._updateTabsNavigation(true);
    };
    /**
     * @desc bind window scroll event
     * @private
     */
    BSSSwiperTabsComponent.prototype._bindScroll = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _bindScroll"));
        if (this._isScrollEventOff) {
            if (!this._torPopup && !this._isBrowserForSticky) {
                this._globalWindow.on("scroll.".concat(this._config.componentId), this._toolbox._.throttle(this._toolbox._.bind(this._updateTabsNavigation, this, false), 200));
            }
            this._isScrollEventOff = false;
        }
    };
    /**
     * @desc unbind window scroll event
     * @private
     */
    BSSSwiperTabsComponent.prototype._unbindScroll = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _unbindScroll"));
        this._globalWindow.off("scroll.".concat(this._config.componentId));
        this._isScrollEventOff = true;
    };
    /**
     * @desc bind window resize event
     * @private
     */
    BSSSwiperTabsComponent.prototype._bindResize = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _bindResize"));
        if (this._isResizeEventOff) {
            if (this._fixedNavigation) {
                this._window.on("resize.".concat(this._config.componentId), this._toolbox._.throttle(this._toolbox._.bind(this._onResizeFixedTabNavigation, this), 200));
            }
            this._isResizeEventOff = false;
        }
    };
    /**
     * @desc unbind window scroll event
     * @private
     */
    BSSSwiperTabsComponent.prototype._unbindResize = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _unbindResize"));
        this._window.off("resize.".concat(this._config.componentId));
        this._isResizeEventOff = true;
    };
    /**
     * @desc destroys infohints, trigger swiper and content swiper, and call super method
     * @public
     * @override
     */
    BSSSwiperTabsComponent.prototype.destroy = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : destroy"));
        var length = this._infohints.length;
        if (length > 0) {
            for (var i = 0; i < length; i += 1) {
                this._infohints[i].destroy();
            }
        }
        if (this._mobileWrapperInfohint) {
            this._mobileWrapperInfohint.destroy();
        }
        this._tabsContent.destroy(true, true);
        if (!this.isNoTabsTriggers) {
            this._tabsTriggers.destroy(true, true);
        }
        this._unbindResize();
        _super.prototype.destroy.call(this);
    };
    /**
     * @desc switch off component - remove valid product or destroy swiper tabs
     * @param {Array} prodIds - array of invalid products ids
     * @emits {bss-entity-destroy-$ENTITY-INSTANCE-ID} emit event when there is no products for swiper tabs
     * @public
     * @override
     */
    BSSSwiperTabsComponent.prototype.switchOffProduct = function (prodIds) {
        if (prodIds === void 0) { prodIds = null; }
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : switchOffProduct | Params: "), prodIds);
        var sliderProducts = [];
        var invalidSlidesIdx = [];
        var slides = this.isNoTabsTriggers
            ? this._tabsContent.slides
            : this._tabsTriggers.slides;
        for (var i = 0, length_11 = slides.length; i < length_11; i += 1) {
            if (this._toolbox.$(slides[i]).data('product')) {
                var prodId = this._toolbox.$(slides[i]).data('product').toString(); // product id is a string value
                sliderProducts.push(prodId);
                if (this._isProductInvalid(prodIds, prodId)) {
                    invalidSlidesIdx.push(i);
                }
            }
        }
        // check if all swiper tabs products must be removed (if there is no valid products left)
        // if yes: sent destroy event to entity builder (do not destroy swiper-tabs component)
        if (this._toolbox._.difference(sliderProducts, prodIds).length === 0) {
            this._sendInvalidProductsMsg();
        }
        // else: if there are some invalid products, remove them
        else if (invalidSlidesIdx.length > 0) {
            this._removeInvalidProducts(invalidSlidesIdx, prodIds);
        }
    };
    /**
     * Check if there is some invalid product
     * @param prodIds
     * @returns {boolean}
     * @private
     */
    BSSSwiperTabsComponent.prototype._isProductInvalid = function (prodIds, prodId) {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _productIdsAreInvalid"));
        return this._toolbox._.findIndex(prodIds, function (id) { return id === prodId; }) >= 0;
    };
    /**
     * Sent destroy event to entity builder (do not destroy swiper-tabs component)
     * @private
     */
    BSSSwiperTabsComponent.prototype._sendInvalidProductsMsg = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _sendInvalidProductsMsg"));
        var errorMsg = {
            errorMsg: "All products for component \"".concat(this._config.componentType, "\" with ID \"").concat(this._config.componentId, "\" are invalid."),
        };
        this._eventManager.publish("bss-entity-destroy-".concat(this._config.entityInstanceId), this._componentName, errorMsg);
    };
    /**
     * If there are someRemove invalid products
     * @param {number[]} invalidSlidesIdx array of invalid slider indexes
     * @param {string[]} prodIds array of invalid products ids
     * @private
     */
    BSSSwiperTabsComponent.prototype._removeInvalidProducts = function (invalidSlidesIdx, prodIds) {
        if (prodIds === void 0) { prodIds = []; }
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _removeInvalidProducts | Params:"), invalidSlidesIdx, prodIds);
        // unsubscribe triggers click events
        this._removeTabChangeEvents();
        if (!this.isNoTabsTriggers) {
            var length_12 = invalidSlidesIdx.length;
            this._removeInvalidProductFromNativeSwiper(length_12);
            // remove tabs and content slides with invalid products
            this._tabsTriggers.removeSlide(invalidSlidesIdx);
            this._tabsTriggers.update();
        }
        this._tabsContent.removeSlide(invalidSlidesIdx);
        this._tabsContent.update();
        // remove invalid trigger from config
        this._toolbox._.pullAt(this._config.triggers, invalidSlidesIdx);
        // update _triggerSlides
        this._triggerSlides = this._toolbox
            .$("#".concat(this._config.componentId, " .bss-swiper-tabs-nav"))
            .find('.swiper-slide');
        // change data-index for content tabs
        var contentSliders = this._toolbox.$("#".concat(this._config.componentId, " .bss-swiper-tabs-content .bss-swiper-tabs-content_slide"));
        for (var i = 0, length_13 = contentSliders.length; i < length_13; i += 1) {
            this._toolbox.$(contentSliders[i]).attr('data-index', i);
        }
        // subscribe click events
        this._addTabChangeEvents();
        // slide trigger and content slides to the first element
        if (!this.isNoTabsTriggers) {
            this._tabsTriggers.slideTo(0, 0);
        }
        this._tabsContent.slideTo(0, 0);
        // update current slide index
        this._currentSliderIndex = 0;
        // update initial slide for the use of _onEntityCreated to activate a proper tab when products are removed
        this._config.contentSwiperConfiguration.initialSlide = 0;
        // remove trigger and set active slide
        if (!this.isNoTabsTriggers) {
            this._setActiveSlide(this._tabsTriggers, false);
        }
        this._setActiveSlide(this._tabsContent, false);
        // update current info
        this._updateCurrent();
    };
    /**
     * Remove invalid sliders from variables of native swiper instance
     * @param {number} invalidSlidersLength amoount of invalid sliders
     * @private
     */
    BSSSwiperTabsComponent.prototype._removeInvalidProductFromNativeSwiper = function (invalidSlidersLength) {
        var swiperConfigRef = this._config.triggersSwiperConfiguration;
        if (swiperConfigRef.slidesPerView !== 'auto') {
            // Remove invalid slider from the liist of visible sliders.
            // It used to calculate transition of swiper container.
            swiperConfigRef.slidesPerView -= invalidSlidersLength;
        }
        // update slidesPerView & slidesPerColumn in config for triggers
        this._toolbox._.forEach(swiperConfigRef.breakpoints, function (breakPoint) {
            if (breakPoint.slidesPerView !== 1) {
                breakPoint.slidesPerView -= invalidSlidersLength;
            }
            if (breakPoint.slidesPerColumn !== 1) {
                breakPoint.slidesPerColumn -= invalidSlidersLength;
            }
        });
    };
    /**
     * @desc method hides all open tooltips - qtips
     * @private
     */
    BSSSwiperTabsComponent.prototype._closeInfohints = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _closeInfohints"));
        if (typeof this._infohints !== 'undefined') {
            for (var i = 0, length_14 = this._infohints.length; i < length_14; i += 1) {
                this._infohints[i].hide();
            }
        }
    };
    /**
     * @desc callback on entity created, currently only for ie10 we update swiper with tabs content
     * @private
     */
    BSSSwiperTabsComponent.prototype._onEntityCreated = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _onEntityCreated"));
        this._tabsContent.update();
        this._tabsContent.slideTo(this._config.contentSwiperConfiguration.initialSlide, 0);
        if (!this.isNoTabsTriggers) {
            this._tabsTriggers.update();
            this._tabsTriggers.slideTo(this._config.contentSwiperConfiguration.initialSlide, 0);
            this._initTabsNavigation();
        }
    };
    /**
     * @desc neeeded information about current product
     * @param {String} throwEvent
     * @param {Boolean} [recalculation=false]
     * @param {jQuery|HTMLElement} target
     * @emits {throwEvent}
     * @private
     * @override
     */
    BSSSwiperTabsComponent.prototype._throwTaggingEvent = function (throwEvent, recalculation, target) {
        var _a, _b;
        if (recalculation === void 0) { recalculation = false; }
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _throwTaggingEvent | Params"), throwEvent);
        var currentProduct = target.attr('data-product');
        // event name after replace @productId@
        var throwEventProduct = throwEvent.replace('@productId@', currentProduct);
        var objThrowEventTag = {
            throwEvent: throwEventProduct,
            resultData: this._config.resultData[currentProduct],
            productTexts: this._config.texts[currentProduct],
            productId: currentProduct,
            generalTexts: this._config.texts.general,
        };
        (_b = (_a = this._toolbox.dxpTagging) === null || _a === void 0 ? void 0 : _a[this._toolbox.currentEntity.entityId]) === null || _b === void 0 ? void 0 : _b.publish(throwEventProduct, objThrowEventTag.resultData);
    };
    /**
     * @desc we need to _initializeTagging later, after swiper and infohints are created
     * @override
     * @private
     */
    BSSSwiperTabsComponent.prototype._initializeTagging = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _initializeTagging ABSTRACT OVERRIDE"));
    };
    /**
     * @desc actual _initializeTagging - we need to call this initialization after swiper and infohints are created
     * @private
     */
    BSSSwiperTabsComponent.prototype._initializeTaggingSwiperTabs = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _initializeTaggingSwiperTabs"));
        if (!this._config.tagEvent) {
            logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _initializeTaggingSwiperTabs  | NO TAGGING"));
            return;
        }
        for (var i = 0, length_15 = this._config.tagEvent.length; i < length_15; i += 1) {
            if (this._config.tagEvent[i].onEvent === 'change') {
                this._tabsContent.on('slideChangeTransitionEnd', this._onTaggingEvent.bind(this, this._config.tagEvent[i].throwEvent, this._config.tagEvent[i].throwAfterCalculation));
            }
            else {
                this._componentTemplate
                    .find(this._config.tagEvent[i].selector)
                    .on(this._config.tagEvent[i].onEvent + '.' + this._config.componentId, this._onTaggingEvent.bind(this, this._config.tagEvent[i].throwEvent, this._config.tagEvent[i].throwAfterCalculation));
            }
        }
    };
    /**
     * @param throwEvent
     * @param throwAfterCalculation
     * @param {Event|Swiper} ev - swiper is passed when event is triggered by on change on swiper
     * @override
     * @protected
     */
    BSSSwiperTabsComponent.prototype._onTaggingEvent = function (throwEvent, throwAfterCalculation, ev) {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _onTaggingEvent | Params"), throwEvent, throwAfterCalculation, ev);
        var target;
        // if event is a swiper object -> this._tabsContent, it means that event on change on swiper was triggered
        if (this.isNoTabsTriggers && ev === this._tabsContent) {
            target = this._toolbox.$(this._tabsContent.slides[this._tabsContent.activeIndex]);
        }
        else if (ev === this._tabsContent) {
            target = this._toolbox.$(this._tabsTriggers.slides[this._tabsContent.activeIndex]);
        }
        else {
            target = ev
                ? this._toolbox.$(ev.currentTarget).parents('[data-product]')
                : null;
        }
        if (!throwAfterCalculation) {
            this._throwTaggingEvent(throwEvent, throwAfterCalculation, target);
        }
        else {
            this._tagEventOnThrow = throwEvent;
            this._tagTarget = target;
        }
    };
    /**
     * @desc adjustments for <= ie11
     * @private method
     */
    BSSSwiperTabsComponent.prototype._triggersAdjust = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _triggersAdjust | Params"));
        for (var i = 0; i < this._triggerSlides.length; i += 1) {
            var el = this._triggerSlides[i];
            var $el = this._toolbox.$(el);
            var $valueEl = $el.find('.bss-swiper-tabs--breakText');
            if ($valueEl.length && $el.find('.bss-swiper-tabs-nav_title').length) {
                if ($valueEl.html().length <= 18) {
                    $valueEl.removeClass('bss-swiper-tabs--breakText');
                }
                else if (this._isIEBelow11()) {
                    var $navTitle = $el.find('.bss-swiper-tabs-nav_title');
                    $navTitle.css({ width: $el.width() + 'px' });
                    $navTitle.addClass('bss-swiper-tabs-nav_title--breakText');
                }
            }
        }
    };
    /**
     * @desc set margin bottom for parent container for safari
     * @private method
     */
    BSSSwiperTabsComponent.prototype._setParentContainerMarginBottomForSafari = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _setParentContainerMarginBottomForSafari | Params"));
        var res = this._resolution.getCurrent();
        var marginBottomClass = 'bss-swiper-tabs-wrapper--margin-bottom';
        if (res !== 'xs') {
            this._componentTemplate.addClass(marginBottomClass);
        }
        else {
            this._componentTemplate.removeClass(marginBottomClass);
        }
    };
    /**
     * @desc checks for ie<=11, useful when browser classes not yet available (e.g on init swiper)
     * @private method
     */
    BSSSwiperTabsComponent.prototype._isIEBelow11 = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _isIEBelow11 | Params"));
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');
        var trident = ua.indexOf('Trident/');
        return msie > 0 || trident > 0;
    };
    /**
     * @desc checks for safari, useful when browser classes not yet available (e.g on init swiper)
     * @private method
     */
    BSSSwiperTabsComponent.prototype._isSafari = function () {
        logger.info("SwiperTabsComponent: ".concat(this._config.componentId, " => function : _isSafari | Params"));
        return !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    };
    return BSSSwiperTabsComponent;
}(BSSAbstractComponent));
export default BSSSwiperTabsComponent;
